// UI strings of the rebuilt Sanakirja (layout v2, docs/design/SIVUPALSTA.md "Sanakirja", the word
// page): the voices row, "Esiintyy repliikeissä", the tense control, the per-form panel and the PC
// margin. Finnish per docs/FINNISH-STYLE.md: no jargon ("vokaaliloppuinen", never "vowel-final");
// nothing is truncated.
import { defineArea } from '../area';

export const dictPageFi = {
  /** The verb classes of the wiki in the UI language (Lemma.verbClass). */
  verbClass: { 'vowel-final': 'vokaaliloppuinen', 'consonant-final': 'konsonanttiloppuinen', irregular: 'epäsäännöllinen' } as Record<string, string>,
  voices: 'Äänet',
  peterson: 'Peterson',
  you: 'Sinä',
  record: 'Äänitä',
  closeRecord: 'Sulje äänitys',
  noVoice: 'ei äänitettä',
  // ---- Esiintyy repliikeissä ----
  lines: 'Esiintyy repliikeissä',
  linesAll: (n: number) => `Kaikki ${n} →`,
  linesTitle: (hv: string) => `Repliikit, joissa on ${hv}`,
  linesWait: 'Repliikit löytyvät, kun hakemisto on valmis.',
  linePeterson: 'Peterson',
  lineActor: 'näyttelijä · kuuntelua varten',
  // ---- the inflection table ----
  tense: 'Aikamuoto',
  moodVoice: 'Tapaluokka ja pääluokka',
  // the verb table's pickers, one per choice (phone layout fix 2026-10-07)
  mood: 'Tapaluokka',
  voice: 'Pääluokka',
  polarity: 'Myönteinen vai kielteinen',
  showAll: 'Näytä kaikki',
  showOne: 'Näytä yksi aikamuoto',
  /** The per-form panel (a tapped form: its recordings, stress, flag). */
  form: 'Muoto',
  formClose: 'Sulje muoto',
  // ---- the PC margin ----
  recordings: 'Äänitteet',
  recYes: (who: string) => `${who} ✓`,
  recNo: (who: string) => `${who}: ei vielä`,
  recordForms: 'Äänitä taivutukset',
  formsRecorded: (n: number, of: number) => `Taivutusmuotoja äänitetty ${n}/${of}`,
  flags: 'Merkinnät',
  flagsOpen: (n: number) => (n === 1 ? '1 avoin merkintä tässä sanassa' : `${n} avointa merkintää tässä sanassa`),
  flagsNone: 'Ei avoimia merkintöjä.',
  flagWord: 'Merkitse sana tarkistettavaksi',
  more: 'Lisää sanasta',
  /** Search page margin: the hovered or focused result. */
  preview: 'Esikatselu',
};

export const dictPageEn: typeof dictPageFi = {
  verbClass: { 'vowel-final': 'vowel-final', 'consonant-final': 'consonant-final', irregular: 'irregular' },
  voices: 'Voices',
  peterson: 'Peterson',
  you: 'You',
  record: 'Record',
  closeRecord: 'Close recording',
  noVoice: 'no recording',
  lines: 'In show lines',
  linesAll: (n) => `All ${n} →`,
  linesTitle: (hv) => `Show lines with ${hv}`,
  linesWait: 'The show lines appear once the index is ready.',
  linePeterson: 'Peterson',
  lineActor: 'actor · for listening',
  tense: 'Tense',
  moodVoice: 'Mood and voice',
  mood: 'Mood',
  voice: 'Voice',
  polarity: 'Affirmative or negative',
  showAll: 'Show all',
  showOne: 'Show one tense',
  form: 'Form',
  formClose: 'Close the form',
  recordings: 'Recordings',
  recYes: (who) => `${who} ✓`,
  recNo: (who) => `${who}: not yet`,
  recordForms: 'Record the forms',
  formsRecorded: (n, of) => `Forms recorded ${n}/${of}`,
  flags: 'Flags',
  flagsOpen: (n) => (n === 1 ? '1 open flag on this word' : `${n} open flags on this word`),
  flagsNone: 'No open flags.',
  flagWord: 'Flag the word for review',
  more: 'More about the word',
  preview: 'Preview',
};

// Messages.dictPage (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('dictPage', dictPageFi, dictPageEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof dictPageFi> {}
}
